<template>
  <div class="index">
    <header-top></header-top>
    <main-center></main-center>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop";
import MainCenter from "../components/MainCenter.vue";
export default {
  name: "Index",
  components: {
    HeaderTop,
    MainCenter,
  },
};
</script>

<style lang="less">
.index {
  width: 100%;
  height: 100%;
}
</style>